/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
*
* created by nganesan
* To edit attribute name and long name(desc)
*/

import React from 'react';

class DeleteAttributeComponent extends React.Component {

    constructor(props) {
       super(props)
       this.state = {
          attributeObj: this.props.attributeObj
        };
    }

    handleDelete = (event) => {
        this.props.handleDeleteAttributeClose(
            true, this.props.attributeObj.id);
    }

    handleClose = (event) => {
        this.props.handleDeleteAttributeClose(false);
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }

    render = () => {
        return (
            <div className={"tde-mt-3 tde-mb-3" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                <div>
                    Are you sure you want to delete { this.state.attributeObj.name }?
                </div>
                <br/>
                <div className="tde-footer-btn-group">
                    <button className="tde-btn tde-btn-ok tde-s1" onClick={this.handleDelete}>{ this.getLoc('Delete') }</button>
                    <button className="tde-btn tde-btn-cancel tde-s1 tde-ml-2" onClick={this.handleClose}>{ this.getLoc('Cancel') }</button>
                </div>
            </div>
        );
    }
}

export default DeleteAttributeComponent;
